import { fetchMethod } from './apiGate'
import { API_URL } from '../config'

const CLIENT_LOGIN_LOGO_KEY = 'login.logo'
const CLIENT_LOGIN_WELCOME_TEXT_KEY = 'login.welcome_text'
const CLIENT_LOGIN_BG_KEY = 'login.bg'
const CLIENT_SIDEBAR_MAP_ICON_KEY = 'sidebar.map_icon'
const CLIENT_APP_SQUARE_ICON_KEY = 'app.logo.square'
const CLIENT_CUSTOM_THEME_KEY = 'app.theme.custom'
const CLIENT_CUSTOM_MAP_MARKER = 'map.marker.img_default'
const CLIENT_CUSTOM_MAP_MARKER_ALT = 'map.marker.img_default_alt'

const remoteFetchLoginConfig = async () => {
  return fetchMethod(`${API_URL}/config/theme`, null, 'get', false)
}
export const getCustomMapMarker = () => {
  return window.localStorage.getItem(CLIENT_CUSTOM_MAP_MARKER)
}
export const getCustomMapMarkerAlt = () => {
  return window.localStorage.getItem(CLIENT_CUSTOM_MAP_MARKER_ALT)
}
export const getCustomTheme = () => {
  return window.localStorage.getItem(CLIENT_CUSTOM_THEME_KEY)
    ? JSON.parse(window.localStorage.getItem(CLIENT_CUSTOM_THEME_KEY))
    : null
}
export const getSignInLogo = () => {
  return window.localStorage.getItem(CLIENT_LOGIN_LOGO_KEY)
}
export const getSignInText = () => {
  return window.localStorage.getItem(CLIENT_LOGIN_WELCOME_TEXT_KEY)
}
export const getSidebarMapIcon = () => {
  return window.localStorage.getItem(CLIENT_SIDEBAR_MAP_ICON_KEY)
}
export const getSigninBg = () => {
  return window.localStorage.getItem(CLIENT_LOGIN_BG_KEY)
}
export const getAppIcon = () => {
  return window.localStorage.getItem(CLIENT_APP_SQUARE_ICON_KEY)
}
export const fetchLoginTheme = async () => {
  const res = await remoteFetchLoginConfig()

  if (res && res.data && res.data.data) {
    const loginlogo = res.data.data.filter(
      config => config.key === CLIENT_LOGIN_LOGO_KEY
    )
    if (loginlogo && loginlogo.length > 0 && loginlogo[0].value) {
      window.localStorage.setItem(CLIENT_LOGIN_LOGO_KEY, loginlogo[0].value)
    }
    const logintext = res.data.data.filter(
      config => config.key === CLIENT_LOGIN_WELCOME_TEXT_KEY
    )
    if (logintext && logintext.length > 0 && logintext[0].value) {
      window.localStorage.setItem(
        CLIENT_LOGIN_WELCOME_TEXT_KEY,
        logintext[0].value
      )
    }
    const sidebarmapicon = res.data.data.filter(
      config => config.key === CLIENT_SIDEBAR_MAP_ICON_KEY
    )
    if (
      sidebarmapicon &&
      sidebarmapicon.length > 0 &&
      sidebarmapicon[0].value
    ) {
      window.localStorage.setItem(
        CLIENT_SIDEBAR_MAP_ICON_KEY,
        sidebarmapicon[0].value
      )
    }
    const loginbg = res.data.data.filter(
      config => config.key === CLIENT_LOGIN_BG_KEY
    )
    if (loginbg && loginbg.length > 0 && loginbg[0].value) {
      window.localStorage.setItem(CLIENT_LOGIN_BG_KEY, loginbg[0].value)
    }
    const appsquareicon = res.data.data.filter(
      config => config.key === CLIENT_APP_SQUARE_ICON_KEY
    )
    if (appsquareicon && appsquareicon.length > 0 && appsquareicon[0].value) {
      window.localStorage.setItem(
        CLIENT_APP_SQUARE_ICON_KEY,
        appsquareicon[0].value
      )
    }

    const mapMarker = res.data.data.filter(
      config => config.key === CLIENT_CUSTOM_MAP_MARKER
    )
    if (mapMarker && mapMarker.length > 0 && mapMarker[0].value) {
      window.localStorage.setItem(CLIENT_CUSTOM_MAP_MARKER, mapMarker[0].value)
    }

    const mapMarkerAlt = res.data.data.filter(
      config => config.key === CLIENT_CUSTOM_MAP_MARKER_ALT
    )
    if (mapMarkerAlt && mapMarkerAlt.length > 0 && mapMarkerAlt[0].value) {
      window.localStorage.setItem(
        CLIENT_CUSTOM_MAP_MARKER_ALT,
        mapMarkerAlt[0].value
      )
    }

    const parseCustomTheme = () => {
      const KEY1 = 'theme.primary.main'
      const KEY2 = 'theme.primary.accent'
      const KEY3 = 'theme.secondary.main'
      const KEY4 = 'theme.secondary.accent'
      const KEY5 = 'theme.tertiary.main'
      const KEY6 = 'theme.tertiary.accent'
      const KEY7 = 'theme.quaternary.main'
      const KEY8 = 'theme.quaternary.accent'
      const KEY9 =
        'theme.exceptionalNotResuable.TitleBarColor.fallingBack.to.secondary.accent'

      const startingPoint = {
        primary: { main: null, accent: null },
        secondary: { main: null, accent: null },
        tertiary: { main: null, accent: null },
        quaternary: { main: null, accent: null },
        exceptionalNotResuable: { titleBar: null }
      }
      startingPoint.primary.main =
        res.data.data.filter(config => config.key === KEY1).length === 0
          ? null
          : res.data.data.filter(config => config.key === KEY1)[0].value
      startingPoint.primary.accent =
        res.data.data.filter(config => config.key === KEY2).length === 0
          ? null
          : res.data.data.filter(config => config.key === KEY2)[0].value
      startingPoint.secondary.main =
        res.data.data.filter(config => config.key === KEY3).length === 0
          ? null
          : res.data.data.filter(config => config.key === KEY3)[0].value
      startingPoint.secondary.accent =
        res.data.data.filter(config => config.key === KEY4).length === 0
          ? null
          : res.data.data.filter(config => config.key === KEY4)[0].value
      startingPoint.tertiary.main =
        res.data.data.filter(config => config.key === KEY5).length === 0
          ? null
          : res.data.data.filter(config => config.key === KEY5)[0].value
      startingPoint.tertiary.accent =
        res.data.data.filter(config => config.key === KEY6).length === 0
          ? null
          : res.data.data.filter(config => config.key === KEY6)[0].value
      startingPoint.quaternary.main =
        res.data.data.filter(config => config.key === KEY7).length === 0
          ? null
          : res.data.data.filter(config => config.key === KEY7)[0].value
      startingPoint.quaternary.accent =
        res.data.data.filter(config => config.key === KEY8).length === 0
          ? null
          : res.data.data.filter(config => config.key === KEY8)[0].value
      startingPoint.exceptionalNotResuable.titleBar =
        res.data.data.filter(config => config.key === KEY9).length === 0
          ? startingPoint.secondary.accent
          : res.data.data.filter(config => config.key === KEY9)[0].value

      window.localStorage.setItem(
        CLIENT_CUSTOM_THEME_KEY,
        JSON.stringify(startingPoint)
      )
    }
    parseCustomTheme()
  }
}
